import { useQuery, useQueryClient } from '@tanstack/react-query'
import { searchUserKey, userKey } from './keys'
import { searchUsers } from 'api/user'

export function useSearchUsers({
  keyword,
  enabled,
  staleTime,
}: {
  keyword: string
  enabled?: boolean
  staleTime?: number
}) {
  return useQuery({
    queryKey: searchUserKey(keyword),
    queryFn: () => searchUsers(keyword),
    enabled,
    staleTime: staleTime ?? 0,
  })
}

export const useRefreshUser = () => {
  const queryClient = useQueryClient()
  queryClient.invalidateQueries({ queryKey: userKey })
}
